  (function() {
    window.CartPage = window.CartPage || new function() {
    //runs once per page load
    var self = this;
    
    self.updateCart = function() {
      $s.showLoadingOverlay();
      $s.getJson({url: routes.root_url + '?sections=cart_content', success: async function(data){
        var section = document.querySelector('.cart-content');
        $s.updateDynamicContent(section, data['cart_content']);
        var summaryWrapper = document.querySelector('#cart .summary-column');
        if (section.querySelector('.cart-items')) {
          summaryWrapper.style.display = '';
        } else {
          summaryWrapper.style.display = 'none';
        }
        await $s.globalEval(data['cart_content']);
        $s.hideLoadingOverlay();
      }});
    }

    self.updateItemsQuantity = function(items, quantity){
      var data = {updates: {}}
      items.forEach(function(item) {
        data.updates[item.dataset.key] = quantity;
      });
      postUpdate(data);
    }

    async function postUpdate(data) {
      $s.showLoadingOverlay();
      $s.updateCartItemsQuantity(data).then(async function(cart) {$s.addToCartSuccess();
      }).catch($s.addToCartFail);
    }
  
  };
  //runs every time #cart div is replaced
  if (window.CartCache && CartCache.cart_fetch === null) {
    $s.get({url:'/cart.js'}); //trigger fetch to cache
  }
  var cart = document.getElementById('cart');
  var itemsCount = 0;
  cart.querySelectorAll('.cart-items .quantity-box input[type=number]').forEach(function(item){
    itemsCount += item.value/1;
  });
  var cartCountElement = Array.from(document.querySelectorAll('header .cart-count, .subtotal .cart-count'));
  if(cartCountElement.length > 0) {
    cartCountElement.forEach(x => x.innerHTML = `${itemsCount>0?itemsCount:0}`)
  }
  var cartCountElementCart = document.querySelector('#cart .cart-count');
  if(cartCountElementCart) {
    cartCountElementCart.innerHTML = `(${itemsCount>0?itemsCount:0})`;
  }

  cart.querySelectorAll('.remove').forEach(function(item) {
    item.addEventListener('click', function(e){
      e.preventDefault();
      var items = $s.getItemsToUpdate ? $s.getItemsToUpdate(this.closest('.item'), 0) : [this.closest('.item')];
      CartPage.updateItemsQuantity(items, 0);
    });
  });

  cart.querySelectorAll('.cart-items input[type=number]').forEach(function(item) {
    item.addEventListener('change', function(e){
      var items = $s.getItemsToUpdate ? $s.getItemsToUpdate(this.closest('.item'), this.value) : [this.closest('.item')];
      CartPage.updateItemsQuantity(items, this.value);
    });
  });

  
  var checkNote = document.getElementById('checkbox-cart-note');
  if (checkNote) {
    var checkNoteChange = function() {
      var note = document.getElementById('cart-note');
      if (checkNote.checked) {
        note.setAttribute("style", "display: block!important");
      } else {
        note.style.display = 'none';
        var textarea = note.querySelector('textarea');
        if (textarea.value != '') {
          textarea.value = '';
          $s.dispatchEvent(textarea, 'change');
        }
      }
    }
    checkNote.labels[0].addEventListener('keypress', function(event) {
      if (event.keyCode==13) {
        checkNote.click();
      }
    });
    checkNote.addEventListener('click', checkNoteChange);
    checkNoteChange();
  }
  

  

  if ($s.validateBundlesInJson) {
    $s.getJson({url:'/cart.js'}).then(data=>{
      $s.validateBundlesInJson(data.items);
    })
  }
})();

(function () {
    function addSwymAddedToCartListener() {
        if (window._swat && window._swat.evtLayer) {
            let event = 'sw:addedtocart';
            let listener = function(e) { 
               setTimeout(() => {
                  location.reload();
               }, 300);
            };
            window._swat.evtLayer.addEventListener(event, listener);
        } else {
            setTimeout(addSwymAddedToCartListener, 300);
        }
    }

    const observer = new MutationObserver(function(mutationsList) {
        for (const mutation of mutationsList) {
            if (
                document.body.classList.contains('swym-buttons-loaded')
            ) {
                observer.disconnect();
                setTimeout(addSwymAddedToCartListener, 300);
                break;
            }
        }
    });

    observer.observe(document.body, {
        attributes: true,
        attributeFilter: ['class']
    });
})();